// imports
import JsonApiCollection from '$dependencies/JsonApiCollection';
import BinRequiredActionModel from '$models/bin/BinRequiredActionModel';
import Config from '$root/Config';

// class definition
export default class BinActionCollection extends JsonApiCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || BinRequiredActionModel;
		args.config = {
			url: Config.getUrl('binActions'),
		};
		args.jsonApi = { order: { weight: 'asc' } };
		// call super constructor
		super(args);
	}
}
